// extracted by css-extract-rspack-plugin
export default {"bodymdbold":"DownloadOptionCard-bodymdbold_Fyb"};